module.exports = __webpack_public_path__ + "img/google-ico.4bb7ea54.svg";